import CardWithPopup from './CardWithPopup'
import ClickableCardWithPopup from './ClickableCardWithPopup';

export default CardWithPopup
export { ClickableCardWithPopup }
